import React, { Component } from "react";
import { ArrowDownSmall } from '../icons';

export default class DropdownMenu extends Component {
  constructor(props) {
    super(props);
    this.buildDropdownMenu = this.buildDropdownMenu.bind(this);
    this.buildSlideInMenu = this.buildSlideInMenu.bind(this);
    this.toggleSubMenu = this.toggleSubMenu.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.setScreenSize = this.setScreenSize.bind(this);
    this.state = {
      isOpen: false,
      openSubMenus: {},
      screenSize: ''
    };
  }

  componentDidMount() {
    this.setScreenSize();
    window.addEventListener('resize', this.setScreenSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setScreenSize);
  }

  setScreenSize() {
    const isSmallScreen = window.innerWidth < 1025;
    const screenSize = isSmallScreen ? 'small' : 'large';
    if (screenSize !== this.state.screenSize) {
      this.closeMenu();
      this.setState({ screenSize, isOpen: false });
    }
  }

  closeMenu(e) {
    if (this.dropdownRef && e && this.dropdownRef.contains(e.target)) {
      return;
    }
    document.removeEventListener('click', this.closeMenu);
    this.setState({ isOpen: false });
  }

  openMenu(e) {
    e.stopPropagation();
    if (this.state.screenSize === 'large') {
      document.addEventListener('click', this.closeMenu)
    }
    this.setState({ isOpen: true });
  }

  toggleSubMenu(level, index, isOpen) {
    this.setState((prevState) => {
      return {
        openSubMenus: {
          ...prevState.openSubMenus,
          [level]: {
            ...prevState.openSubMenus[level],
            [index]: isOpen
          }
        }
      }
    });
  }

  buildDropdownMenu(root, level) {
    return (root || []).map(
      (node, i) => {
        if (!node.children || !node.children.length) {
          return (
            <div
              key={`${node.display}-${i}`}
              className={`ps-dropdown-menu-item${node.id.includes('see_all') ? ' see-all-menu-item' : ''}`}
            >
              <a href={node.url}>{node.display}</a>
            </div>
          )
        } else {
          const submenuOpen = this.state.openSubMenus[level] && this.state.openSubMenus[level][i];
          return (
            <div key={node.id}>
              <div
                className='ps-dropdown-nested-menu-btn'
                role="button"
                aria-haspopup="true"
                aria-expanded={submenuOpen}
                onMouseOver={() => this.toggleSubMenu(level, i, true)}
                onMouseOut={() => this.toggleSubMenu(level, i, false)}
              >
                <span>{node.display}</span>
                <ArrowDownSmall className="margin-sm-left" width={24} height={24}/>
                <div
                  className={`ps-dropdown-menu-nested ps-dropdown-menu${submenuOpen ? ' ps-dropdown-menu-open' : ''}`}
                  style={{
                    transform: 'translateX(100%)'
                  }}
                >
                  {this.buildDropdownMenu(node.children, level + 1)}
                </div>
              </div>
            </div>
          )
        }
      }
    );
  }

  buildSlideInMenu(root) {
    return (root || []).map(
      (node, i) => {
        if (!node.children || !node.children.length) {
          return (
            <div
              key={node.id}
              className={`ps-slide-in-menu-item${node.id.includes('see_all') ? ' see-all-menu-item' : ''}`}
            >
              <a href={node.url}>{node.display}</a>
            </div>
          )
        } else {
          return (
            <div
              key={`${node.display}-${i}`}
              className="ps-slide-in-menu-section margin-xl-top"
            >
              <span className="ps-slide-in-menu-header">
                {node.display}
              </span>
              {this.buildSlideInMenu(node.children)}
            </div>
          )
        }
      }
    )
  }

  render() {
    return (
      <div className="ps-dropdown-menu-container">
        <div
          className={`ps-dropdown-menu-btn flex${this.state.isOpen ? ' ps-dropdown-menu-btn-active' : ''}`}
          role="button"
          aria-haspopup="true"
          aria-expanded={this.state.isOpen}
          onClick={this.openMenu}
        >
          {this.props.children}
          <ArrowDownSmall className="margin-sm-left" width={24} height={24}/>
        </div>
        {
          this.state.screenSize === 'large' ? (
            <div
              className={`ps-dropdown-menu${this.state.isOpen ? ' ps-dropdown-menu-open' : ''}`}
              ref={(dropdownDiv) => this.dropdownRef = dropdownDiv}
            >
              {this.buildDropdownMenu(this.props.menuTree, 0)}
            </div>
          ) : (
            <div className={`ps-slide-in-menu${this.state.isOpen ? ' ps-slide-in-menu-open' : ''}`}>
              <div className="ps-slide-in-menu-inner">
                <span
                  className='ps-slide-in-menu-back-btn'
                  role='button'
                  onClick={() => this.setState({ isOpen: false })}
                >
                  <ArrowDownSmall className="margin-sm-left" width={24} height={24}/>
                  Back
                </span>
                {this.buildSlideInMenu(this.props.menuTree)}
              </div>
            </div>
          )
        }
      </div>
    )
  }
}
